(function () {
  var btn    = document.getElementById('wa-btn');
  var menu   = document.getElementById('wa-menu');
  var widget = document.getElementById('wa-widget');
  if (!btn || !menu) return;

  function setMenuTabindex(val) {
    menu.querySelectorAll('a').forEach(function (a) { a.setAttribute('tabindex', val); });
  }
  function open() {
    menu.classList.add('is-open');
    btn.setAttribute('aria-expanded', 'true');
    menu.setAttribute('aria-hidden', 'false');
    setMenuTabindex('0');
  }
  function close() {
    menu.classList.remove('is-open');
    btn.setAttribute('aria-expanded', 'false');
    menu.setAttribute('aria-hidden', 'true');
    setMenuTabindex('-1');
  }

  btn.addEventListener('click', function () {
    menu.classList.contains('is-open') ? close() : open();
  });
  document.addEventListener('click', function (e) {
    if (!btn.contains(e.target) && !menu.contains(e.target)) close();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') close();
  });

  if (widget) {
    var mo = new MutationObserver(syncWithChat);
    function syncWithChat() {
      /* Shopify Inbox 2026 usa <shopify-agent open>; versiones previas
         <inbox-online-store-chat is-open="true"> */
      var chatEl = document.querySelector('shopify-agent, inbox-online-store-chat');
      if (!chatEl) return;
      var isOpen = chatEl.hasAttribute('open') || chatEl.getAttribute('is-open') === 'true';
      widget.style.opacity       = isOpen ? '0' : '';
      widget.style.pointerEvents = isOpen ? 'none' : '';
      widget.style.transform     = isOpen ? 'scale(0.85)' : '';
      mo.observe(chatEl, { attributes: true, attributeFilter: ['is-open', 'open'] });
    }
    mo.observe(document.body, { childList: true, subtree: true });
    syncWithChat();
  }
})();
